import { ErrorBanner } from 'ui/banner';
import { LINKED_WORKFLOWS_LABEL_TEST_ID } from './constants';

const displayText = {
  title: 'Something went wrong...',
  caption: 'Could not fetch linked journeys',
};

export const LinkedWorkflowsQueryErrorBanner = () => (
  <ErrorBanner data-test={LINKED_WORKFLOWS_LABEL_TEST_ID} title={displayText.title}>
    {displayText.caption}
  </ErrorBanner>
);
